import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronArrowDownRightFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M15.605 19.708c-.14.66-.238 1.418-.302 2.292h-2.406c.07-1.032.184-1.961.361-2.792.349-1.638.962-2.987 2.047-4.008H8.2A7.2 7.2 0 0 1 1 8V2h2.4v6a4.8 4.8 0 0 0 4.8 4.8h7.105c-1.085-1.02-1.698-2.37-2.047-4.008-.177-.83-.29-1.76-.36-2.792h2.405c.064.874.162 1.632.302 2.292.298 1.395.766 2.25 1.425 2.833.675.597 1.692 1.035 3.337 1.31.764.127 1.635.214 2.633.272v2.586c-.998.057-1.87.145-2.633.273-1.645.274-2.662.712-3.337 1.31-.66.582-1.127 1.436-1.425 2.832"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ChevronArrowDownRightFilledSize24Glyph.displayName = 'ChevronArrowDownRightFilledSize24Glyph';
